export default "__VITE_ASSET__c8a0d249__"